import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper.ts";
import { modulatorLinkDto } from "@/types/backoffice/dto/modulator/modulator-link-dto.ts";
import { modulatorTypeDtoSchema } from "@/types/backoffice/dto/modulator/modulator-type-dto.ts";

export const modulatorDtoSchema = z.object({
  csId: branded.modulatorCsId,
  hwId: branded.modulatorHwId,
  location: z.string().nullable(),
  modnum: z.number().nullable(),
  momboxCsId: branded.pilotCsId.nullable(),
  momboxId: branded.pilotHwId.nullable(),
  neuronId: z.string().nullable(),
  serialNumber: branded.serialNumber.nullable(),
  siteId: branded.siteId,
  type: modulatorTypeDtoSchema,
  links: z.array(modulatorLinkDto),
});

export type TModulatorDto = z.infer<typeof modulatorDtoSchema>;
